import React, { FC, Dispatch, SetStateAction } from 'react';

import Grid from '@mui/material/Grid';

import FilterSelectInput from '../../form/components/FilterSelectInput';
import FilterBar from '../../listPage/FilterBar';

interface IssueReportsFilterBarProps {
  filterValues: Record<string, string>;
  setFilterValues: React.Dispatch<any>;
  fetchIssueReports: (
    controllerName: string,
    searchFilters: any,
    inputPage: number,
    query?: string,
    sort?: string,
  ) => void;
  setPage: Dispatch<SetStateAction<number>>;
  setSortParam: Dispatch<SetStateAction<string>>;
  searchQuery: string;
  setSearchQuery: Dispatch<SetStateAction<string>>;
}

const IssueReportsFilterBar: React.FC<IssueReportsFilterBarProps> = (props) => {
  const { filterValues, setFilterValues, fetchIssueReports, setPage, setSortParam, searchQuery, setSearchQuery } =
    props;

  const handleFilterChange = (key, value) => {
    let updatedFilterValues = { ...filterValues };

    updatedFilterValues[key] = value;
    sessionStorage.setItem('issueReportFilterValues', JSON.stringify(updatedFilterValues));
    setFilterValues(updatedFilterValues);
    if (['status_eq', 'reportable_type_eq'].includes(key)) {
      fetchIssueReports('issue_reports', updatedFilterValues, 1);
    }
  };

  const statusOptions = [
    { label: 'Submitted', value: 'Submitted' },
    { label: 'Reviewed', value: 'Reviewed' },
  ];

  const typeOptions = [
    { label: 'Chiller Logs', value: 'ChillerLog' },
    { label: 'AHRI Certificates', value: 'AhriCertificate' },
    { label: 'Backflow Job', value: 'BackflowJobItem' },
  ];

  const IssueReportsFilters: FC = () => {
    return (
      <Grid container spacing={2}>
        <Grid item>
          <FilterSelectInput
            value={filterValues?.status_eq}
            defaultChoice={{ label: 'All', value: 'all' }}
            choices={statusOptions}
            valueChanged={(value) => handleFilterChange('status_eq', value)}
            label="Status"
          />
        </Grid>
        <Grid item>
          <FilterSelectInput
            value={filterValues?.reportable_type_eq}
            defaultChoice={{ label: 'All', value: 'all' }}
            choices={typeOptions}
            valueChanged={(value) => handleFilterChange('reportable_type_eq', value)}
            label="Type"
          />
        </Grid>
      </Grid>
    );
  };

  return (
    <FilterBar
      filters={<IssueReportsFilters />}
      filterValues={filterValues}
      setFilterValues={setFilterValues}
      controller="issue_reports"
      clearedFilterSetting={{}}
      fetchRecordsList={fetchIssueReports}
      setPage={setPage}
      setSortParam={setSortParam}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      queryPlaceholder={'Search by Message'}
    />
  );
};

export default IssueReportsFilterBar;
